import * as Yup from 'yup';

const editReferrerSchemaWaiting = Yup.object().shape({
    name: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Nama Lengkap harus diisi')
        .max(60, 'Nama tidak boleh lebih dari 60 karakter.')
        .matches(/^[A-Za-z ]*$/, 'Nama hanya boleh berisi huruf dan spasi'),
    email: Yup.string()
        .email('Masukkan alamat email yang valid.')
        .required('Alamat Email harus diisi')
        .max(234, 'Email tidak boleh lebih dari 234 karakter.')
})

export default editReferrerSchemaWaiting;